import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenericLookupComponent } from './generic-lookup/generic-lookup.component';
import { DynamicFormsModule } from '../dynamic-forms/dynamic-forms.module';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MaterialModule } from '../material/material.module';
import { FormsModule } from '@angular/forms';
import { DatatableModule } from '../datatable/datatable.module';
import { RouterModule } from '@angular/router';
import { UtilityModule } from '../utility/utility.module';
import { AuthModule } from '../auth/auth.module';
import { MatIconModule } from '@angular/material/icon';
import { PrefixPipe } from '../utility/prefix.pipe';
import { EntityFormatterPipe } from '../utility/entity-formatter.pipe';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    UtilityModule,
    MaterialModule,
    FormsModule,
    DynamicFormsModule,
    DatatableModule,
    RouterModule,
    AuthModule,
    GenericLookupComponent,
    MatIconModule,
    PrefixPipe,
    EntityFormatterPipe,
  ],
  exports: [GenericLookupComponent],
  providers: [
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: { width: '80vw', data: null, hasBackdrop: true, disableClose: true, restoreFocus: true },
    },
  ],
})
export class LookupModule {}
